import { Component, HostListener, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import { FormControl } from '@angular/forms';
import { BillingFormComponent } from 'ngx-intellforce-billing/lib/components/billing-form/billing-form.component';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit {

  showOrderButton: boolean = true;

  currentyear: any;
  weekago: any;
  threedaysago: any;
  showLine: boolean = false;
  @ViewChild('form', { static: true }) form!: BillingFormComponent;


  ngOnInit(): void {
    this.yesterday = new Date();

    this.threedaysago = new Date();
    this.threedaysago.setDate(new Date().getDate() - 3);

    this.weekago = new Date();
    this.weekago.setDate(new Date().getDate() - 8);

    this.currentyear = new Date();
    this.currentyear.setDate(new Date().getDate());

    this.form.formGroup.addControl('language', new FormControl(window.navigator.language));
    this.form.formGroup.addControl('screenHeight', new FormControl(window.screen.height));
    this.form.formGroup.addControl('screenWidth', new FormControl(window.screen.width));
    this.form.formGroup.addControl('timezone', new FormControl(new Date().getTimezoneOffset()));
    this.form.formGroup.addControl('javaEnabled', new FormControl(window.navigator.javaEnabled()));
    const newLocal = this;
    newLocal.form.formGroup.addControl('javascriptEnabled', new FormControl(true));
    this.form.formGroup.addControl('screenColorDepth', new FormControl(window.screen.colorDepth));
  }

  title = 'boxesC';
  yesterday!: Date;
  isShowFaq = true;
  isClicked = true;
  toggleDisplayFaq() {
    this.isShowFaq = !this.isShowFaq;
  }

  changePaymentType(type: String) {
	this.form.paymentType = type;
  }
  
  //// scrol to function
  scroll(el: HTMLElement) {
    el.scrollIntoView({behavior: 'smooth'});
  }


  isInViewport(el: HTMLElement) {
    const rect = el.getBoundingClientRect();
    
    return (
       // rect.top >= 0 &&
       // rect.left >= 0 &&
        rect.bottom >= 0

        //&& rect.right <= (window.innerWidth || document.documentElement.clientWidth)

    );
}

@HostListener('window:scroll', ['$event'])
onScroll() {
   let show = this.isInViewport(document.getElementById('bundle_wrap') as HTMLElement);
   this.showOrderButton = show;
  }
}
